import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormPyramide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-pyramide, prism"><path d="M1.75 16.1111L12 2.75L22.25 16.1111L12 21.25L1.75 16.1111Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12 4V20.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFormPyramide;
